module.exports = __webpack_public_path__ + "static/media/gtx_printer@2x.b880c6b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gtx_printer@2x.png
// module id = 158
// module chunks = 0